// ReCaptchaWrapper.tsx
import React, { useImperativeHandle } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import type { ReCAPTCHAProps } from 'react-google-recaptcha';

// Fixes TS2786 by asserting ReCAPTCHA as any, but keeps props typed
const ReCaptchaWrapper = React.forwardRef<ReCAPTCHA, ReCAPTCHAProps>((props, ref) => {
  const innerRef = React.useRef<ReCAPTCHA>(null);

  useImperativeHandle(ref, () => innerRef.current as ReCAPTCHA);

  // Cast to any to avoid JSX type-checking issues
  const ReCaptchaAny = ReCAPTCHA as any;

  return <ReCaptchaAny ref={innerRef} {...props} />;
});

export default ReCaptchaWrapper;
